module.exports = __webpack_public_path__ + "static/cosi7s-b6f0954847812b1ccd0064cb5ba1fb4c.jpg";